import React, { useState } from 'react';
import PropTypes from 'prop-types';
import TextField from 'src/components/TextField';
import Checkbox from 'src/components/Checkbox';
import { useTranslation } from 'react-i18next';
import s from './ColumnFilters.styles';

const ColumnPopupFilterList = ({
  value,
  onChange,
  column: { filterValues, filterNull },
}) => {
  const [search, setSearch] = useState('');
  const { t } = useTranslation();

  const changeSelected = (filterValue, isChecked) => {
    const newValue = [...value];
    if (isChecked) {
      newValue.push(filterValue);
    } else {
      newValue.splice(newValue.indexOf(filterValue), 1);
    }
    onChange(newValue);
  };

  const getValue = v => {
    const numberValue = +v;

    if (Number.isNaN(numberValue)) {
      return v;
    }

    return numberValue;
  };
  const sortedFilterValues = filterValues.sort((a, b) => {
    const checkedA = value.indexOf(getValue(a.value)) !== -1;
    const checkedB = value.indexOf(getValue(b.value)) !== -1;

    if (checkedA && !checkedB) {
      return -1;
    }
    if (checkedB && !checkedA) {
      return 1;
    }
    if (a.label === b.label) {
      return 0;
    }
    return a.label > b.label ? 1 : -1;
  });

  return (
    <s.MorePopup list>
      <s.PopupTextField>
        <TextField
          onChange={e => setSearch(e.target.value)}
          placeholder={t('SEARCH_FIELD')}
          value={search}
        />
        <s.MoreSearchIcon name="search" search />
      </s.PopupTextField>
      <s.MoreContent>
        {filterNull && (
          <Checkbox
            label={filterNull}
            onChange={e => changeSelected(null, e.target.checked)}
            value={value.indexOf(null) !== -1}
          />
        )}
        {sortedFilterValues.map((filterValue, index) => {
          if (
            search &&
            filterValue.label.toLowerCase().indexOf(search.toLowerCase()) === -1
          ) {
            return null;
          }

          return (
            <Checkbox
              key={index}
              label={filterValue.label}
              onChange={e =>
                changeSelected(getValue(filterValue.value), e.target.checked)
              }
              value={value.indexOf(getValue(filterValue.value)) !== -1}
            />
          );
        })}
      </s.MoreContent>
    </s.MorePopup>
  );
};

ColumnPopupFilterList.propTypes = {
  column: PropTypes.shape({
    label: PropTypes.string,
    filterValues: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.number,
        label: PropTypes.string,
      }),
    ),
    filterNull: PropTypes.string,
  }),
  onChange: PropTypes.func,
  value: PropTypes.arrayOf(PropTypes.string),
};

export default React.memo(ColumnPopupFilterList);
